import { useStyles } from "./styles";
import { AnchorProps } from "./types";

export const Anchor = ({ children, href, onClick, style }: AnchorProps) => {
  const styles = useStyles();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <a
      style={{ ...styles.anchor, ...style }}
      href={href}
      target={href ? "_blank" : undefined}
      rel={href ? "noopener noreferrer" : undefined}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};
